<template>
  <div>
    <vs-row class="mb-2"
      v-for="(log, index) in booking.changeLog"
      :key="'changeLog-' + booking.id + '-' + index"
    >
    <vs-col>
      <span>{{ formatDate(log.created) }} - {{ log.user }}:</span>
      <p
        v-for="(change, changeIndex) in log.changes"
        :key="
          'changeLog-' + booking.id + '-' + index + '-change-' + changeIndex
        "
      >
        {{ getLogChangeString(change) }}
      </p>
    </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { BOOKING_CHANGE_TYPE } from '@/store/modules/marcom/data-model/bookings';

export default {
  components: {},
  props: {
    booking: Object,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "users/user",
    }),
  },
  methods: {
    formatDate(date) {
      let mDate = moment(date);
      return mDate.format("DD-MM-YYYY HH:mm");
    },
    getLogChangeString(change) {
      let s = `${BOOKING_CHANGE_TYPE.nameof(change.changeType)} changed values! : `;

      switch(change.changeType) {
        case BOOKING_CHANGE_TYPE.Arrival:
        case BOOKING_CHANGE_TYPE.Departure: {
          s = s + `${this.formatDate(change.oldValue)} => ${this.formatDate(change.newValue)}`;
          break;
        }
        default: {
          s = s + `${change.oldValue} => ${change.newValue}`;
          break;
        }
      }

      return s;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
